(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_cf277ef"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pethealer-refill-grid')) {
  customElements.define('pethealer-refill-grid', class extends HTMLElement {
    connectedCallback() {
      if (this.onVariantChange) return;
      this.onVariantChange = (event) => {
        const select = event.target.closest('[data-refill-select]');
        if (!select || !this.contains(select)) return;
        const card = select.closest('[data-refill-card]');
        const option = select.selectedOptions[0];
        if (!option) return;
        card.querySelector('[data-refill-price]').textContent = option.dataset.refillMoney;
        const compare = card.querySelector('s[data-refill-compare]');
        compare.textContent = option.dataset.refillCompare || '';
        compare.hidden = !option.dataset.refillCompare;
        const button = card.querySelector('[type="submit"]');
        const available = option.dataset.refillAvailable === 'true';
        button.disabled = !available;
        button.removeAttribute('aria-disabled');
        button.querySelector('span').textContent = available ? this.dataset.addLabel : this.dataset.soldLabel;
        const form = card.querySelector('product-form');
        form.error = false;
        if (form.handleErrorMessage) form.handleErrorMessage();
        card.querySelectorAll('[data-refill-link]').forEach(link => {
          const url = new URL(link.href);
          url.searchParams.set('variant', select.value);
          link.href = url.href;
        });
      };
      this.addEventListener('change', this.onVariantChange);
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.onVariantChange);
      this.onVariantChange = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
